export default function About() {
  return (
    <section id="about" className="py-32 px-16 bg-[#E8E4F3]">
      <div className="max-w-4xl mx-auto text-center">
        {/* Illustration */}
        <div className="mb-16 flex justify-center">
          <img
            src="https://public.readdy.ai/ai/img_res/289234b6ddede9b01cd51b306c1b2318.jpg"
            alt="인솔 구조"
            className="w-full max-w-2xl h-64 object-contain object-top"
          />
        </div>

        {/* Content */}
        <div className="space-y-6">
          <p className="text-sm text-gray-500 tracking-widest uppercase">우리의 미션</p>
          <h2 className="text-5xl font-bold text-gray-900 leading-relaxed">
            우리는 모든 사람이 건강한 발과 바른 자세로 일상을 누릴 수 있도록 과학적으로 설계된 맞춤형 인솔을 제공합니다. 발의 건강은 전신 건강의 시작입니다 ✨
          </h2>
        </div>
      </div>
    </section>
  );
}
